var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCdsWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37518 0.938348L0.251614 16.7397C0.08681 17.025 3.05017e-05 17.3487 8.0392e-09 17.6783C-3.04856e-05 18.0078 0.0866891 18.3315 0.25144 18.6169C0.416191 18.9023 0.653167 19.1392 0.938545 19.304C1.22392 19.4688 1.54765 19.5555 1.87717 19.5555H20.1228C20.4524 19.5555 20.7761 19.4688 21.0615 19.304C21.3468 19.1392 21.5838 18.9023 21.7486 18.6169C21.9133 18.3315 22 18.0078 22 17.6783C22 17.3487 21.9132 17.025 21.7484 16.7397L12.6258 0.938348C12.4611 0.653053 12.2242 0.416143 11.9389 0.251429C11.6536 0.0867147 11.3299 0 11.0005 0C10.6711 0 10.3474 0.0867147 10.0621 0.251429C9.77682 0.416143 9.5399 0.653053 9.37518 0.938348Z",
    fill: "#CC4A44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1195 5.81174H10.8815C10.2956 5.81174 9.82056 6.28673 9.82056 6.87267V11.9437C9.82056 12.5297 10.2956 13.0047 10.8815 13.0047H11.1195C11.7054 13.0047 12.1804 12.5297 12.1804 11.9437V6.87267C12.1804 6.28673 11.7054 5.81174 11.1195 5.81174Z",
    fill: "#FFF7ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0005 17.0266C11.6521 17.0266 12.1804 16.4984 12.1804 15.8467C12.1804 15.1951 11.6521 14.6668 11.0005 14.6668C10.3488 14.6668 9.82056 15.1951 9.82056 15.8467C9.82056 16.4984 10.3488 17.0266 11.0005 17.0266Z",
    fill: "#FFF7ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdsWarning);
export default __webpack_public_path__ + "static/media/cds_warning.9ce2353a8a6b4c534a4e1d27c57270e8.svg";
export { ForwardRef as ReactComponent };